export default "__VITE_ASSET__Ck6t3OY___"